export enum CurrencyCode {
  GBP = "GBP",
  USD = "USD",
}
